export function initCursorBoembel() {
  const follower = document.getElementById("follower")

  if (follower && follower.style.getPropertyValue("display") !== "none") {
    let isFollowing = false

    function setCursorProperties(x, y) {
      follower.style.setProperty("--left", Math.floor(x))
      follower.style.setProperty("--top", Math.floor(y))
    }

    function followCursor(e) {
      if (isFollowing) return
      isFollowing = true

      requestAnimationFrame(() => {
        setCursorProperties(e.clientX, e.clientY)
        isFollowing = false
      })
    }

    setCursorProperties(window.innerWidth / 2, window.innerHeight / 2)
    document.addEventListener(
      "mousemove",
      (_e) => {
        follower.style.opacity = 1
      },
      { once: true },
    )

    document.addEventListener("mousemove", followCursor)
  }
}
